export default "__VITE_ASSET__DDLob9K9__"